// src/config/api.config.ts
import { env } from './env.config';

export const API_BASE_URL = env.API_URL;

export const API_ROOT = '/api';
export const AUTH_ROOT = '/auth';
export const AI_ROOT = '/ai';
export const SCHOOL_ROOT = '/schools';
export const USER_ROOT = '/users';
export const LEARNING_ROOT = '/learning';
export const COMMUNICATION_ROOT = '/communication';
export const STORAGE_ROOT = '/storage';
export const HEALTH_ROOT = '/health';
export const DOCS_ROOT = '/docs';

export const API_ENDPOINTS = {
  AUTH: {
    ME: `${AUTH_ROOT}/me`,
    LOGOUT: `${AUTH_ROOT}/logout`,
  },
  SCHOOL: {
    ROOT: SCHOOL_ROOT,
    BY_ID: (id: string | number) => `${SCHOOL_ROOT}/${id}`,
    COURSES: (id: string | number) => `${SCHOOL_ROOT}/${id}/courses`,
    CLASSROOMS: (id: string | number) => `${SCHOOL_ROOT}/${id}/classrooms`,
    STUDENTS: (id: string | number) => `${SCHOOL_ROOT}/${id}/students`,
    TEACHERS: (id: string | number) => `${SCHOOL_ROOT}/${id}/teachers`,
    ADMINS: (id: string | number) => `${SCHOOL_ROOT}/${id}/admins`,
    PARENTS: (id: string | number) => `${SCHOOL_ROOT}/${id}/parents`,
    STAFF: (id: string | number) => `${SCHOOL_ROOT}/${id}/staff`,
    SUBJECTS: (id: string | number) => `${SCHOOL_ROOT}/${id}/subjects`,
    TIMESLOTS: (id: string | number) => `${SCHOOL_ROOT}/${id}/timeslots`,
    TIMESLOT_GROUPS: (id: string | number) =>
      `${SCHOOL_ROOT}/${id}/timeslot-groups`,
    TIMESLOT_GROUP_TIMESLOTS: (id: string | number) =>
      `${SCHOOL_ROOT}/${id}/timeslot-group-timeslots`,
    TIMESLOT_GROUP_TIMESLOT_GROUPS: (id: string | number) =>
      `${SCHOOL_ROOT}/${id}/timeslot-group-timeslot-groups`,
    TIMESLOT_GROUP_TIMESLOT_GROUP_TIMESLOTS: (id: string | number) =>
      `${SCHOOL_ROOT}/${id}/timeslot-group-timeslot-group-timeslots`,
    TIMESLOT_GROUP_TIMESLOT_GROUP_TIMESLOT_GROUPS: (id: string | number) =>
      `${SCHOOL_ROOT}/${id}/timeslot-group-timeslot-group-timeslot-groups`,
  },
  USER: {
    ROOT: USER_ROOT,
    BY_ID: (id: string | number) => `${USER_ROOT}/${id}`,
    BY_EMAIL: (email: string) => `${USER_ROOT}/email/${email}`,
    BY_USERNAME: (username: string) => `${USER_ROOT}/username/${username}`,
  },
  AI: {
    ROOT: AI_ROOT,
    HEALTH: `${AI_ROOT}/health`,
    EXERCISE_PDF: `${AI_ROOT}/exercise/create-pdf/`,
    SUMMARY: `${AI_ROOT}/summary`,
    QUIZ: `${AI_ROOT}/quiz`,
    QA_PDF: `${AI_ROOT}/qa/create-pdf`,
    CLOZE_QUIZ_GENERATOR: `${AI_ROOT}/quiz/cloze`,
    QUIZ_GENERATOR: `${AI_ROOT}/quiz-generator`,
    GRADE_COPY: `${AI_ROOT}/grade-copy`,
  },
  COMMUNICATION: {
    ROOT: COMMUNICATION_ROOT,
    ANNOUNCEMENTS: {
      ROOT: `${COMMUNICATION_ROOT}/announcements`,
      BY_ID: (id: string | number) => `${COMMUNICATION_ROOT}/announcements/${id}`,
    },
    CAMPAIGNS: {
      ROOT: `${COMMUNICATION_ROOT}/campaigns`,
      BY_ID: (id: string | number) => `${COMMUNICATION_ROOT}/campaigns/${id}`,
    },
    EMAILS: {
      ROOT: `${COMMUNICATION_ROOT}/emails`,
      BY_ID: (id: string | number) => `${COMMUNICATION_ROOT}/emails/${id}`,
    },
    HEALTH: `${COMMUNICATION_ROOT}/health`,
  },
};
